var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpload2Icon = function SvgUpload2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.375 7.447h1.732v7.929c0 .103.084.187.188.187H12.7a.19.19 0 0 0 .187-.187v-7.93h1.737c.157 0 .244-.18.148-.302l-2.625-3.323a.188.188 0 0 0-.296 0L9.227 7.142a.188.188 0 0 0 .148.305m11.203 7.225h-1.406a.19.19 0 0 0-.188.188v3.61H5.016v-3.61a.19.19 0 0 0-.188-.187H3.422a.19.19 0 0 0-.188.187v4.64c0 .416.336.75.75.75h16.032a.75.75 0 0 0 .75-.75v-4.64a.19.19 0 0 0-.188-.187"
  })));
};
export default SvgUpload2Icon;